import { render, staticRenderFns } from "./CallsignsRda.vue?vue&type=template&id=155d963e&"
import script from "./CallsignsRda.vue?vue&type=script&lang=js&"
export * from "./CallsignsRda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports